import logo from "../assets/images/clarion-call-logo.png";
import poster from "../assets/images/clarion-call-poster.jpg";
import { Ticket } from "../types/event";

export const campaign = {
  channel: 1,
  title: "Isezerano Rishya Concert",
  fullTitle: "The Clarion Call Choir – Isezerano Rishya Concert",
  host: "The Clarion Call Choir",
  organiser: "The Clarion Call Choir",
  poweredBy: "Ishema Tickets",
  cadence: "A night of praise",
  lineup: "3:00 PM",
  city: "Kigali",
  logo,
  poster,
  ticketTypes: ["REGULAR", "VIP", "VVIP"],
  fallbackSlug: "isezerano-rishya-concert",
};

export function isCampaignEvent(title?: string, slug?: string) {
  const normalizedTitle = title?.toLowerCase() ?? "";
  const normalizedSlug = slug?.toLowerCase() ?? "";

  return (
    normalizedTitle.includes("isezerano rishya") ||
    normalizedTitle.includes("clarion call") ||
    normalizedSlug.includes("isezerano-rishya") ||
    normalizedSlug.includes("clarion-call")
  );
}

export function normalizeTicketType(type: string) {
  return type.trim().toUpperCase();
}

export function displayTicketType(type: string) {
  return normalizeTicketType(type) === "DONATION"
    ? "INVITATION"
    : normalizeTicketType(type);
}

export function sortTickets(pricings: Ticket[] = []) {
  return [...pricings].sort((a, b) => {
    const aIndex = campaign.ticketTypes.indexOf(normalizeTicketType(a.type));
    const bIndex = campaign.ticketTypes.indexOf(normalizeTicketType(b.type));

    return (aIndex === -1 ? 99 : aIndex) - (bIndex === -1 ? 99 : bIndex);
  });
}

export function formatCampaignCurrency(currency?: string) {
  const normalized = currency?.trim().toUpperCase();

  if (!normalized || normalized === "RW") return "RWF";

  return normalized;
}
